import {useEffect, useState} from "react";
import * as React from "react";
import {FormattedMessage} from "react-intl";
import {Stack, Typography} from "@mui/material";
import {FileApi} from "../../../../../modules/ftp/api/FileApi";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {RequestVisitorApi} from "../../../../../modules/vms/api/RequestVisitorApi";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import LoadingBackdrop from "../../../../../components/LoadingBackdrop";
import set = Reflect.set;

export type FinishTipsProps = {
    requestVisitor: RequestVisitorDto;
    onBackHome: () => void;
};

// 倒计时
let secondsInterval: NodeJS.Timeout;

const FinishTips: React.FC<FinishTipsProps> = (props) => {

    const [seconds, setSeconds] = useState(10);
    const [loading, setLoading] = useState(false);
    const [checkinSuccess, setCheckinSuccess] = useState(false);

    useEffect(() => {
        handleCheckinRegister();
        // 画面退出销毁倒计时
        return () => {
            if (secondsInterval) {
                clearInterval(secondsInterval);
            }
        }
    }, []);

    const handleCheckinRegister = async () => {
        setLoading(true);
        if (props.requestVisitor.attachFilesArray && props.requestVisitor.attachFilesArray.length > 0) {
            const attachFiles = props.requestVisitor.attachFiles ? JSON.parse(props.requestVisitor.attachFiles) : [];
            const newAttachFiles = attachFiles.concat(props.requestVisitor.attachFilesArray);
            props.requestVisitor.attachFiles = JSON.stringify(newAttachFiles);
        }
        const responseResult = await RequestVisitorApi.checkinRegister(props.requestVisitor);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCheckinSuccess(true);
            setSeconds(10);
            secondsInterval = setInterval(() => {
                setSeconds(seconds => seconds - 1);
            }, 1000);
        }
        setLoading(false);
    }

    useEffect(() => {
        if (seconds <= 0) {
            clearInterval(secondsInterval);
            props.onBackHome();
        }
    }, [seconds])

    return (
        <Stack spacing={5} justifyContent={'center'} alignItems={'center'}>
            <LoadingBackdrop open={loading} onClick={() => setLoading(false)}/>

            {
                checkinSuccess ?
                    <div>
                        <Typography variant="h3" gutterBottom>
                            <FormattedMessage id={'VMS_REQUEST_VISITOR_CHECKIN_SUCCESSFUL'}/>
                        </Typography>

                        <Typography variant="h3" gutterBottom>
                            <FormattedMessage id={'VMS_REQUEST_VISITOR_CHECKIN_SUCCESSFUL_AUTO_CLOSE'}
                                              values={{seconds: seconds}}/>
                        </Typography>
                    </div> :
                    <Typography variant="h3" gutterBottom>
                        <FormattedMessage id={'VMS_REQUEST_VISITOR_CHECKIN_LOADING'}/>
                    </Typography>
            }

        </Stack>
    )
};

export default FinishTips;